import { Component, OnInit } from '@angular/core';
import { WebConstants } from 'src/app/util/web.constants';
import { GeofenceService } from 'src/app/services/geofence.service';
import { GeofenceDetailService } from 'src/app/services/geofencedetail.service';
import { GeofenceZoneService } from 'src/app/services/geofencezone.service';
import { ZoneService } from 'src/app/services/zone.service';
import { first } from 'rxjs/operators';
declare const google: any;

@Component({
  selector: 'app-all-geofence',
  templateUrl: './all-geofence.component.html',
  styleUrls: ['./all-geofence.component.scss']
})
export class AllGeofenceComponent implements OnInit {

  public title: string = WebConstants.MENU_NAMES.ALL_GEOFENCE;

  lat = 51.678418;
  lng = 7.809007;

  mapZoom = 18;
  mapType = "satellite";

  public drawingManager : any;
  public createPolygon = false;
  public polygon :any;
  public polyArrayLatLng: any[] = [];
  geofenceZoneData: any;
  public zoneList: any = [];
  info: boolean = true;
  allGeofenceIds : any;
  allGeofenceNames: any;
  allGeofenceDetails: any;
  zoneData: any;

  polygonData:any = {
    "strokeColor" : "#BBBAD2",
    "strokeOpacity" : 0.2,
    "strokeWeight" : 2,
    "fillColor" : "#BBBAD2",
    "fillOpacity" : 0.35,
    "draggable" : false,
    "editable" : true,
    "visible" : true,
    "ZonePaths": []
    }


  constructor
  (
    public geofenceService: GeofenceService,
    public geofenceDetailService: GeofenceDetailService,
    public geofenceZoneService: GeofenceZoneService,
    public zoneService: ZoneService
  ) 
  { 
    
  }

  ngOnInit() {

    this.polygonData.ZonePaths = 
    [
      [
        {"lat":24.86424739527252,	"lng":67.14690604423083},
        {"lat":24.86375580995435,	"lng":67.1471528074602},
        {"lat":24.86430093414956,	"lng":67.14867630218066},
        {"lat":24.86478278299944,	"lng":67.14846172545947}
      ],
      [
        {"lat":24.86321666000459,	"lng":67.14404297551368},
        {"lat":24.86200958546995,	"lng":67.1445686884806},
        {"lat":24.86071488758905,	"lng":67.13876438817238},
        {"lat":24.86174675316223,	"lng":67.1387322016642}
      ]
    ]

    this.getAllGeofenceDetails();
    this.getAllGeofenceName();
    this.getAllGeofenceZone();
    this.getAllZone();
  }

  getAllGeofenceName(): void {
    this.geofenceService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.allGeofenceNames = response.data;
        } else {
          console.log("Geofence API Error!");
        }
      });
  }


  getAllGeofenceDetails(): void {
    this.geofenceDetailService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {

          this.allGeofenceIds = [...new Set(response.data.map(item => item.geofenceId))];
          var allGeofencesByIds = [];

          for(let i=0; i<this.allGeofenceIds.length; i++){
            var geofence = response.data.filter((geoData)=>{
              return geoData.geofenceId == this.allGeofenceIds[i]
            });

            geofence.sort((a, b) => {
              return a.sequence - b.sequence;
            });
            
            for(let j=0; j<geofence.length; j++){
              geofence[j].lat = parseFloat(geofence[j].lat);
              geofence[j].lng = parseFloat(geofence[j].lng);
            }

            allGeofencesByIds.push(geofence);
          }

          this.allGeofenceDetails = allGeofencesByIds;
        } 
        else {
          console.log("Geofence Detail API Error!");
        }
      });
  }


  filterGeofenceName(geoId): void{
    var geoName = this.allGeofenceNames.filter((geoData)=>{
      return geoData.geofenceId == geoId;
    })

    return geoName[0].geofenceName;
  }


  getAllGeofenceZone(): void {
    this.geofenceZoneService.getAll()
    .pipe(first())
    .subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.geofenceZoneData = response.data;
      } else {
        console.log("Zone API Error!");
      }
    });
  }


  getAllZone(): void {
    this.zoneService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.zoneData = response.data;
        } else {
          console.log("Zone API Error!");
        }
      });
  }


  getAllZoneIdsByGeofenceId(geoId):void{
    this.zoneList = [];
    var geoZone = this.geofenceZoneData.filter(x=>x.geofenceId == geoId);

    geoZone.forEach(element =>{
      this.zoneList.push(element.zoneId);
    });
  }


  getZoneNameByZoneId(zoneId){
    let myObj = this.zoneData.filter(x=>x.zoneId == zoneId)[0];

    if(myObj == undefined){
      let myZone = "Zone Deleted!";
      return myZone;
    }
    else{
      let myZone = Object.assign({},myObj);
      return myZone.zoneName;
    }
  }

  wt(evt) { 
    this.mapType= evt;
  }

  viewInfo(){
    this.info = true;
  }

  closeInfo(){
    this.info = false;
  }


  initDrawingManager(map: any) {
    const input = document.getElementById("pac-input") as HTMLInputElement;
    const searchBox = new google.maps.places.SearchBox(input);

    map.addListener("bounds_changed", () => {
      searchBox.setBounds(map.getBounds());
    });

    searchBox.addListener("places_changed", () => {
      const places = searchBox.getPlaces();
  
      if (places.length == 0) {
        return;
      }
  
      let markers = [];
      // Clear out the old markers.
      markers.forEach((marker) => {
        marker.setMap(null);
      });
      markers = [];
  
      // For each place, get the icon, name and location.
      const bounds = new google.maps.LatLngBounds();
  
      places.forEach((place) => {
        if (!place.geometry || !place.geometry.location) {
          console.log("Returned place contains no geometry");
          return;
        }
  
        const icon = {
          url: place.icon,
          size: new google.maps.Size(0, 0),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25),
        };
  
        // Create a marker for each place.
        markers.push(
          new google.maps.Marker({
            map,
            icon,
            title: place.name,
            position: place.geometry.location,
          })
        );
        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      map.fitBounds(bounds);
    });

    const options = {
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT,
        drawingModes: ["polygon"]
      },
      polygonOptions: {
        draggable: false,
        editable: false
      },
      drawingMode: google.maps.drawing.OverlayType.POLYGON
    };

    this.drawingManager = new google.maps.drawing.DrawingManager(options);
    this.drawingManager.setMap(map);
    const that = this;
    google.maps.event.addListener(this.drawingManager, "polygoncomplete", function(polygon) {
      const len = polygon.getPath().getLength();
      const polyArrayLatLng = [];

      for (let i = 0; i < len; i++) {
        const vertex = polygon.getPath().getAt(i);
        const vertexLatLng = { latitude: vertex.lat(), longtitude: vertex.lng(),sequence: i+1 };
        polyArrayLatLng.push(vertexLatLng);
      }
      
      that.polyArrayLatLng = polyArrayLatLng;

      if(that.polygon){
        that.polygon.setMap(null);
      }
      that.polygon = polygon;
    });
  }

}
